import { useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { Proposal } from "../types";

// The new name shows at once. A refused rename restores the one before it,
// unless a newer rename has replaced it since. With `persist` off the name is
// only held, for a proposal whose first save will store it.
export const useProposalRename = (
  proposal: Proposal,
  onRename: (proposal: Proposal, name: string) => Promise<unknown>,
  persist = true
) => {
  const { t } = useTranslation();
  const [name, setName] = useState(proposal.name);
  const [pending, setPending] = useState(false);

  const rename = async (next: string) => {
    const previous = name;
    setName(next);
    if (!persist) return;
    setPending(true);
    try {
      await onRename({ ...proposal, name: previous }, next);
    } catch {
      setName((current) => (current === next ? previous : current));
      toast.error(t("contracts.proposals.editor.renameError"));
    } finally {
      setPending(false);
    }
  };

  return { name, rename, pending };
};
